import { Eye, EyeOff } from "lucide-react";
import React, { SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import InputError from "../../../../components/InputError";
import { Input } from "../../../../components/ui/input";
import { Label } from "../../../../components/ui/label";
import { ErrorType, InputRegistrasi } from "../../../../types";

export default function FormAkun({
  form,
  setForm,
  error,
}: {
  form: InputRegistrasi;
  setForm: React.Dispatch<SetStateAction<InputRegistrasi>>;
  error: ErrorType | null;
}) {
  const { t } = useTranslation();

  // State untuk toggle visibilitas
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (
    <div className="w-full mx-auto flex flex-col gap-y-3">
      {/* Nama Lengkap */}
      <div>
        <Label>{t("guest.layout.register.label.nama-lengkap")}</Label>
        <Input
          required
          type="text"
          placeholder={`type ${t(
            "guest.layout.register.label.nama-lengkap",
          )}...`}
          value={form.nama_lengkap}
          onChange={(event) =>
            setForm((prev) => ({ ...prev, nama_lengkap: event.target.value }))
          }
        />
        <InputError text={error?.errors?.nama_lengkap?.join(",")} />
      </div>

      {/* Email */}
      <div>
        <Label>Email</Label>
        <Input
          required
          type="email"
          placeholder="type Email..."
          value={form.email}
          onChange={(event) =>
            setForm((prev) => ({ ...prev, email: event.target.value }))
          }
        />
        <InputError text={error?.errors?.email?.join(",")} />
      </div>

      {/* Password */}
      <div>
        <Label>Password</Label>
        <div className="relative">
          <Input
            required
            // Toggle tipe input
            type={showPassword ? "text" : "password"}
            placeholder="type Password..."
            value={form.password}
            onChange={(event) =>
              setForm((prev) => ({ ...prev, password: event.target.value }))
            }
            // Class ini menyembunyikan ikon mata bawaan browser (Edge/IE)
            className="pr-10 [&::-ms-reveal]:hidden [&::-ms-clear]:hidden"
          />
          <button
            type="button" // Penting agar tidak men-submit form
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
            tabIndex={-1} // Agar tidak bisa difokuskan dengan tab (opsional)
          >
            {showPassword ? (
              <EyeOff className="h-4 w-4" />
            ) : (
              <Eye className="h-4 w-4" />
            )}
          </button>
        </div>
        <InputError text={error?.errors?.password?.join(",")} />
      </div>

      {/* Konfirmasi Password */}
      <div>
        <Label>{t("guest.layout.register.label.konfirmasi-password")}</Label>
        <div className="relative">
          <Input
            required
            // Toggle tipe input
            type={showConfirmPassword ? "text" : "password"}
            placeholder={`type ${t(
              "guest.layout.register.label.konfirmasi-password",
            )}...`}
            value={form.password_confirmation}
            onChange={(event) =>
              setForm((prev) => ({
                ...prev,
                password_confirmation: event.target.value,
              }))
            }
            // Class ini menyembunyikan ikon mata bawaan browser (Edge/IE)
            className="pr-10 [&::-ms-reveal]:hidden [&::-ms-clear]:hidden"
          />
          <button
            type="button"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
            tabIndex={-1}
          >
            {showConfirmPassword ? (
              <EyeOff className="h-4 w-4" />
            ) : (
              <Eye className="h-4 w-4" />
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
